<!--  -->
<template>
  <div class="container" ref="container" :style="{width:showMission?'500px':'0'}">
    <div id="mission">
      <div class="util">
        <img
          class="util-img"
          src="../assets/images/icon_close.png"
          @click="hideMission"
          :style="{transform:showMission?'':'scale(-1) translateX(-20px)'}"
          alt
        />
      </div>
      <div class="search" ref="search" v-show="activeNav!='/user'" v-if="userInfo!= null">
        <el-input
          v-if="userInfo.isAdmin&&activeNav=='/index'"
          placeholder="请输入任务名称、接收人或单号"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @change="inputChange"
          clearable
        ></el-input>
        <el-input
          v-if="userInfo.isAdmin&&activeNav=='/common'"
          placeholder="请输入任务名称、接收人"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @change="inputChange"
          clearable
        ></el-input>
        <el-input
          v-if="!userInfo.isAdmin&&activeNav=='/index'"
          placeholder="请输入任务名称"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @change="inputChange"
          clearable
        ></el-input>
        <el-input
          v-if="!userInfo.isAdmin&&activeNav=='/common'"
          placeholder="请输入任务名称"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @change="inputChange"
          clearable
        ></el-input>
        <el-select v-model="select" size="mini" style="width:80px;">
          <el-option label="全部" value="全部"></el-option>
          <el-option label="未完成" value="未完成"></el-option>
          <el-option label="已完成" value="已完成"></el-option>
        </el-select>
      </div>
      <div id="accept" v-show="activeNav=='/user'">
        <div class="accept-static">任务接收者</div>
        <div class="accept-static-content">接收发布端发布的核查处置任务或通用任务，并对任务进行处理回传，通常为下属镇街的执法人员。</div>
      </div>
      <div
        class="infinite-list-wrapper"
        style="overflow:auto"
        :style="scrollHeight"
        v-show="activeNav!='/user'"
        v-loading="searchLoading"
      >
        <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
          <!-- 显示全部 -->
          <li
            v-for="(item,index) in missionList"
            :key="index+'a'"
            class="list-item"
            @click="toMissionDetail(item.missionId||item.commonId)"
            v-show="select=='全部'"
          >
            <div class="mission-item">
              <div class="timeAndTip">
                <span class="time">{{item.createDate}}</span>
                <el-tag
                  v-if="item.progress!=100&&activeNav=='/index'"
                  :type="item.tag.type"
                  size="mini"
                >{{item.tag.name}}</el-tag>
              </div>
              <div class="missionName">
                <div class="missionName-span" v-if="activeNav=='/index'">
                  {{item.missionName}}
                  <span class="backtip" v-if="item.isBack"></span>
                </div>
                <div class="missionName-span" v-if="activeNav=='/common'">
                  {{item.commonName}}
                  <el-tag v-if="item.unread" effect="dark" color="red" size="mini">新</el-tag>
                </div>
                <div>
                  <el-tag v-if="item.hasNew" size="mini">有更新</el-tag>
                </div>
              </div>
              <div class="oddNum" v-if="activeNav=='/index'">
                抽样单编号：
                <span class="mission-content">{{item.oddNum}}</span>
              </div>
              <div class="accept" v-if="activeNav=='/index'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.mission_accepts"
                  :key="index+'b'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="accept" v-if="activeNav=='/common'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.common_accepts"
                  :key="index+'c'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="progress" v-if="activeNav=='/index'">
                <div class="progress-txt">
                  <span style="color:#999999;">进度：</span>
                  "{{item.currentStage}}" {{item.currentState}}
                </div>
                <div class="progress-line">
                  <el-progress
                    :stroke-width="10"
                    :color="'#87CD0E'"
                    :percentage="item.progress"
                    style="width:100px;"
                  ></el-progress>
                </div>
              </div>
              <el-progress
                v-if="activeNav=='/common'"
                :stroke-width="10"
                :color="'#87CD0E'"
                :percentage="item.progress"
              ></el-progress>
            </div>
          </li>
          <!-- 显示全部已完成 -->
          <li
            v-for="(item,index) in missionList"
            :key="index+'e'"
            class="list-item"
            @click="toMissionDetail(item.missionId||item.commonId)"
            v-show="select=='已完成'&&item.progress==100"
          >
            <div class="mission-item">
              <div class="timeAndTip">
                <span class="time">{{item.createDate}}</span>
                <el-tag
                  v-if="item.progress==100&&activeNav=='/index'"
                  :type="item.tag.type"
                  size="mini"
                >{{item.tag.name}}</el-tag>
              </div>
              <div class="missionName">
                <div class="missionName-span" v-if="activeNav=='/index'">
                  {{item.missionName}}
                  <span class="backtip" v-if="item.isBack"></span>
                </div>
                <div class="missionName-span" v-if="activeNav=='/common'">{{item.commonName}}</div>
                <div>
                  <el-tag v-if="item.hasNew" size="mini">有更新</el-tag>
                </div>
              </div>
              <div class="oddNum" v-if="activeNav=='/index'">
                抽样单编号：
                <span class="mission-content">{{item.oddNum}}</span>
              </div>
              <div class="accept" v-if="activeNav=='/index'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.mission_accepts"
                  :key="index+'g'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="accept" v-if="activeNav=='/common'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.common_accepts"
                  :key="index+'h'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="progress" v-if="activeNav=='/index'">
                <div class="progress-txt">
                  <span style="color:#999999;">进度：</span>
                  "{{item.currentStage}}" {{item.currentState}}
                </div>
                <div class="progress-line">
                  <el-progress
                    :stroke-width="10"
                    :color="'#87CD0E'"
                    :percentage="item.progress"
                    style="width:100px;"
                  ></el-progress>
                </div>
              </div>
              <el-progress
                v-if="activeNav=='/common'"
                :stroke-width="10"
                :color="'#87CD0E'"
                :percentage="item.progress"
              ></el-progress>
            </div>
          </li>
          <!-- 显示全部未完成 -->
          <li
            v-for="(item,index) in missionList"
            :key="index+'f'"
            class="list-item"
            @click="toMissionDetail(item.missionId||item.commonId)"
            v-show="select=='未完成'&&item.progress!=100"
          >
            <div class="mission-item">
              <div class="timeAndTip">
                <span class="time">{{item.createDate}}</span>
                <el-tag
                  v-if="item.progress!=100&&activeNav=='/index'"
                  :type="item.tag.type"
                  size="mini"
                >{{item.tag.name}}</el-tag>
              </div>
              <div class="missionName">
                <div class="missionName-span" v-if="activeNav=='/index'">
                  {{item.missionName}}
                  <span class="backtip" v-if="item.isBack"></span>
                </div>
                <div class="missionName-span" v-if="activeNav=='/common'">{{item.commonName}}</div>
                <div>
                  <el-tag v-if="item.hasNew" size="mini">有更新</el-tag>
                </div>
              </div>
              <div class="oddNum" v-if="activeNav=='/index'">
                抽样单编号：
                <span class="mission-content">{{item.oddNum}}</span>
              </div>
              <div class="accept" v-if="activeNav=='/index'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.mission_accepts"
                  :key="index+'g'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="accept" v-if="activeNav=='/common'">
                接收人：
                <span
                  class="mission-content"
                  v-for="(item1,index) in item.common_accepts"
                  :key="index+'h'"
                >{{item1.department}}{{item1.nickname}}&nbsp;&nbsp;</span>
              </div>
              <div class="progress" v-if="activeNav=='/index'">
                <div class="progress-txt">
                  <span style="color:#999999;">进度：</span>
                  "{{item.currentStage}}" {{item.currentState}}
                </div>
                <div class="progress-line">
                  <!-- <el-progress
                    :text-inside="true"
                    :stroke-width="15"
                    :percentage="item.progress"
                    :color="'#87CD0E'"
                  ></el-progress>-->
                  <el-progress
                    :stroke-width="10"
                    :color="'#87CD0E'"
                    :percentage="item.progress"
                    style="width:100px;"
                  ></el-progress>
                </div>
              </div>
              <el-progress
                v-if="activeNav=='/common'"
                :stroke-width="10"
                :color="'#87CD0E'"
                :percentage="item.progress"
              ></el-progress>
            </div>
          </li>
        </ul>
        <p v-if="loading" class="tips">
          加载中...
          <i class="el-icon-loading"></i>
        </p>
        <p v-if="noMore" class="tips">{{tipsText}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMission,
  getMissionBySearch,
  getCommon,
  getCommonBySearch
} from "../api/index";
export default {
  components: {},
  props: ["activeNav"],
  data() {
    return {
      showMission: true, //下拉加载更多
      page: 1,
      loading: false,
      scrollHeight: null,
      missionList: [],
      count: 0,
      searchValue: "",
      searchLoading: false, //搜索
      select: "全部",
      tipsText: "没有更多了"
    };
  },
  computed: {
    noMore() {
      return this.missionList.length == this.count;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  watch: {
    missionList(val) {
      if (val.length == 0) {
        this.tipsText = "暂无任务";
      } else {
        if (this.tipsText == "暂无任务") {
          this.tipsText = "没有更多了...";
        }
      }
    },
    activeNav(val) {
      if (val == "/index" || val == "/common") {
        //console.log(val);
        this.page = 1;
        this.missionList.length = 0;
        this.getMission();
      }
    }
  },
  methods: {
    inputChange(val) {
      this.searchLoading = true;
      if (val != "") {
        //如果输入为空则变回所有搜索
        if (this.activeNav == "/index") {
          getMissionBySearch(this.$store.state.user.userInfo.isAdmin, val)
            .then(res => {
              this.searchLoading = false;
              if (res.status == 200) {
                this.missionList = res.data.missionList;
                //重置page
                this.page = 1;
                this.count = res.data.missionList.length;
              }
            })
            .catch(reason => {
              this.searchLoading = false;
              console.log(reason);
            });
        } else {
          getCommonBySearch(this.$store.state.user.userInfo.isAdmin, val).then(
            res => {
              this.searchLoading = false;
              if (res.status == 200) {
                this.missionList = res.data.missionList;
                console.log("missionList=>", this.missionList);
                //重置page
                this.page = 1;
                this.count = res.data.missionList.length;
              }
            }
          );
        }
      } else {
        //又特定搜索变回来下拉加载更多 需要清空数组 否则数组长度不一致(因为下拉加载更多属于数组连接)
        this.missionList.length = 0;
        this.getMission();
      }
    },
    hideMission() {
      this.showMission ? (this.showMission = false) : (this.showMission = true);
    },
    load() {
      this.loading = true;
      this.getMission();
    },
    getMission() {
      if (this.activeNav == "/index") {
        getMission(this.page)
          .then(res => {
            if (res.status == 200) {
              this.missionList = this.missionList.concat(res.data.missions);
              // console.log("missionList2=>",this.missionList)
              this.count = res.data.count;
              this.loading = false;
              this.page++;
              if (this.searchLoading) {
                this.searchLoading = false;
              }
            }
          })
          .catch(reason => {
            this.loading = false;
          });
      } else {
        getCommon(this.page)
          .then(res => {
            if (res.status == 200) {
              if (!this.$store.state.user.userInfo.isAdmin) {
                //每次获取新的数据来都和本地缓存对比 找出未读的一项或是长度变化的一项
                let data =
                  JSON.parse(window.localStorage.getItem("common")) || {};
                if (
                  //如果不存在这个键 都为未读
                  !data.hasOwnProperty(this.$store.state.user.userInfo.username)
                ) {
                  res.data.missions.forEach(item1 => {
                    item1.unread = true;
                  });
                } else {
                  res.data.missions.forEach(item1 => {
                    let flag = false;
                    data[this.$store.state.user.userInfo.username].forEach(
                      item2 => {
                        if (
                          item2.commonId == item1.commonId &&
                          item2.sub_tasks.length == item1.sub_tasks.length
                        ) {
                          if (!item2.unread) {
                            //找到相同的且子任务长度不变的
                            flag = true;
                          }
                        }
                      }
                    );
                    item1.unread = flag ? false : true;
                  });
                }
              } else {
                //管理员的话就查看子任务有没有被更新了的项
                res.data.missions.forEach(item1 => {
                  item1.sub_tasks.forEach(item2 => {
                    if (item2.hasNew) {
                      item1.hasNew = true;
                    }
                  });
                });
              }

              this.missionList = this.missionList.concat(res.data.missions);
              console.log("missionList2=>", this.missionList);
              this.count = res.data.count;
              this.loading = false;
              this.page++;
              console.log(res.data);
              if (this.searchLoading) {
                this.searchLoading = false;
              }
            }
          })
          .catch(reason => {
            this.loading = false;
          });
      }
    },
    toMissionDetail(missionId) {
      //根据用户角色跳转不同页面
      //console.log(missionId)
      if (this.activeNav == "/index") {
        if (this.$store.state.user.userInfo.isAdmin) {
          if (this.$route.name == "missionShow") {
            this.$root.eventHub.$emit("missionIdChangeShow", missionId);
          }
          if (this.$route.query.missionId != missionId) {
            this.$router.replace({
              name: "missionShow",
              query: { missionId: missionId }
            });
          }
        } else {
          if (this.$route.name == "missionEdit") {
            this.$root.eventHub.$emit("missionIdChangeEdit", missionId);
          }
          if (this.$route.query.missionId != missionId) {
            this.$router.replace({
              name: "missionEdit",
              query: { missionId: missionId }
            });
          }
        }
      } else {
        if (this.$store.state.user.userInfo.isAdmin) {
          if (this.$route.name == "commonShow") {
            this.$root.eventHub.$emit("commonIdChangeShow", missionId);
          }
          if (this.$route.query.commonId != missionId) {
            this.$router.replace({
              name: "commonShow",
              query: { commonId: missionId }
            });
          }
        } else {
          if (this.$route.name == "commonEdit") {
            this.$root.eventHub.$emit("commonIdChangeEdit", missionId);
          }
          if (this.$route.query.commonId != missionId) {
            this.$router.replace({
              name: "commonEdit",
              query: { commonId: missionId }
            });
            //如果当前项是未读 则取消未读
            this.missionList.forEach((item, index) => {
              
              if (item.commonId == missionId) {
                console.log(this.$store.state.user.message)
                item.unread = false;
                this.$set(this.missionList, index, item);
                if (!this.$store.state.user.userInfo.isAdmin) {
                  if (window.localStorage.getItem("common")) {
                    let data = JSON.parse(
                      window.localStorage.getItem("common")
                    );
                    data[
                      this.$store.state.user.userInfo.username
                    ] = this.missionList;
                    window.localStorage.setItem("common", JSON.stringify(data));
                  } else {
                    let data = {};
                    data[
                      this.$store.state.user.userInfo.username
                    ] = this.missionList;
                    window.localStorage.setItem("common", JSON.stringify(data));
                  }
                }
              }
            });
            // for (let i = 0; i<this.$store.state.user.message.length; i++) {
            //     var message=this.$store.state.user.message[i]
            //     if(message.taskId==missionId&&!message.isRead){
            //       this.$set(message,"isRead",1)
            //     }
             
            // }
          }
        }
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //console.log(this.activeNav);
    this.$root.eventHub.$off("missionCreate"); //处理组件切换绑定多次的情况
    this.$root.eventHub.$on("missionCreate", missionDataCreate => {
      this.missionList.unshift(missionDataCreate);
    });

    this.$root.eventHub.$off("missionShow"); //处理组件切换绑定多次的情况
    this.$root.eventHub.$on("missionShow", missionData => {
      for (var i = 0; i < this.missionList.length; i++) {
        if (this.missionList[i].missionId == missionData.missionId) {
          this.missionList[i].tag = missionData.tag;
          this.missionList[i].currentStage = missionData.currentStage;
          this.missionList[i].currentState = missionData.currentState;
          this.missionList[i].progress = missionData.progress;
          this.$set(this.missionList, i, this.missionList[i]);
          break;
        }
      }
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.scrollHeight = {
      height:
        this.$refs.container.clientHeight -
        this.$refs.search.clientHeight +
        "px"
    };
    this.getMission();

    window.addEventListener("beforeunload", () => {
      if (!this.$store.state.user.userInfo.isAdmin) {
        if (window.localStorage.getItem("common")) {
          let data = JSON.parse(window.localStorage.getItem("common"));
          data[this.$store.state.user.userInfo.username] = this.missionList;
          window.localStorage.setItem("common", JSON.stringify(data));
        } else {
          let data = {};
          data[this.$store.state.user.userInfo.username] = this.missionList;
          window.localStorage.setItem("common", JSON.stringify(data));
        }
      }
    });
  }
};
</script>
<style scope lang="less">
@text-color: #9d9797;
@margin-bottom: 8px;
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.container {
  background-color: #fff;
  margin: 10px 0 10px 10px;
  border-radius: 5px;
  position: relative;
}
.border-bottom {
  border-bottom-style: solid;
  border-bottom-color: #eeeeee;
  border-bottom-width: 1px;
}
#mission {
  height: 100%;
  border-right-style: solid;
  border-right-color: #eeeeee;
  border-right-width: 1px;
  .border-bottom();
  overflow: auto;
}

.util {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -10px;
}

#mission::-webkit-scrollbar {
  display: none;
}

.search {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px;
  .border-bottom();
}

// .container,
// .util {
//   transition: width 0.8s;
//   -webkit-transition: width 0.8s; /* Safari */
// }

// .util {
//   transition: all 0.8s;
//   -webkit-transition: all 0.8s; /* Safari */
// }

.search > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}

.search-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}

//给div固定高度防止缩小时被撑开
.search-icon div {
  height: 18px;
}

.mission-item {
  margin: 10px;
  border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px;
  padding-top: 5px;
  padding-bottom: 10px;
  cursor: pointer;
  position: relative;
}

.missionName {
  font-size: 16px;
  color: #333333;
  min-width: 100px;
  max-width: 250px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.missionName-span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  padding-right: 10px;
  margin: 5px 0;
}

.progress {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #999999;
  margin-bottom: 5px;
  //width: 100%;
}

.progress-txt {
  color: #666666;
  margin-right: 10px;
}

.progress-line {
  width: 20%;
  margin-top: -3px;
}

.el-progress-bar__outer {
  margin: 10px 8px 5px 0;
}

.accept,
.oddNum {
  margin-top: 5px;
  font-size: 14px;
  color: #999999;
}

.mission-content,
.time,
.tips {
  color: #666666;
}

.timeAndTip {
  margin: 10px 0;
}
.time {
  font-size: 12px;
  margin-right: 5px;
}
.tips {
  text-align: center;
  font-size: 12px;
}

#accept {
  padding: 40px 20px 20px;
}

.accept-static {
  font-size: 18px;
  color: #333333;
}

.accept-static-content {
  font-size: 14px;
  color: #999999;
  margin-top: 20px;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999999;
  font-size: 12px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999999;
  font-size: 12px;
}

.backtip {
  background-color: red;
  width: 8px;
  height: 8px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.el-input__inner {
  padding-left: 8px;
}
.el-progress__text {
  font-size: 12px !important;
  margin-left: 5px !important;
  margin-top: 5px !important;
}
.el-progress-bar__outer {
  background-color: #e6e6e6;
}
</style>


// WEBPACK FOOTER //
// src/components/mission.vue